module.exports = __webpack_public_path__ + "static/media/Ellipse-4.6b0b5abd.svg";